import {
  Dialog,
  DialogBackdrop,
  DialogPanel,
  DialogTitle,
} from "@headlessui/react";
import { ButtonAsButton } from "@made-people/blueprint-button";
import { useTranslate } from "@made-people/grease-translations";
import { readRichText } from "./return-step-heading";

type ShowSummaryConfirmationModalProps = {
  isOpen: boolean;
  header?: string;
  subHeader?: string;
  isSubmitting: boolean;
  onConfirm: () => void;
  onCancel: () => void;
};

export const ShowSummaryConfirmationModal = ({
  isOpen,
  header,
  subHeader,
  isSubmitting,
  onConfirm,
  onCancel,
}: ShowSummaryConfirmationModalProps) => {
  const translate = useTranslate();
  const subHeaderHtml = readRichText(subHeader);
  const heading = header?.trim();

  return (
    <Dialog open={isOpen} onClose={onCancel} className="relative z-[100]">
      <DialogBackdrop className="fixed inset-0 bg-black/40" />
      <div className="fixed inset-0 flex items-center justify-center p-4">
        <DialogPanel className="relative w-full max-w-[500px] rounded-md bg-white p-6 text-center shadow-xl lg:p-8">
          {heading && (
            <DialogTitle className="font-secondary text-heading-md text-black">
              {heading}
            </DialogTitle>
          )}

          {subHeaderHtml && (
            <div
              className="mt-4 font-primary text-body-md text-black [&_p]:m-0"
              dangerouslySetInnerHTML={{ __html: subHeaderHtml }}
            />
          )}

          <div className="mt-8 flex justify-center gap-4">
            <div className="w-full max-w-xs">
              <ButtonAsButton
                label={translate("return_flow_confirmation_modal_no_button")}
                type="button"
                disabled={isSubmitting}
                onClick={onCancel}
                variants={{ width: "full", rounded: "md", color: "white" }}
                className="!bg-sand-200 hover:!bg-sand-300 active:!bg-sand-200 !text-black"
              />
            </div>
            <div className="w-full max-w-xs">
              <ButtonAsButton
                label={translate("return_flow_confirmation_modal_yes_button")}
                type="button"
                disabled={isSubmitting}
                progress={isSubmitting ? "loading" : "default"}
                onClick={onConfirm}
                variants={{ width: "full", rounded: "md", color: "black" }}
              />
            </div>
          </div>
        </DialogPanel>
      </div>
    </Dialog>
  );
};
